<section class="relative flex flex-col items-end justify-start">
    @let syncState = syncQueueService.syncState$ | async;
    @if (syncQueueService.queueItems.length || syncState == SyncState.IDLE) {
        <div class="relative h-6 w-auto cursor-pointer text-white sm:h-5 sm:w-5" #anchor (click)="togglePopup()">
            <bizz-icon iconName="download" class="header-popup-icon"></bizz-icon>
            <div class="absolute -bottom-1.5 -right-2.5 flex size-4 items-center justify-center rounded-full bg-white">
                @switch(syncState) {
                    @case(SyncState.IDLE){
                        @if(fetchOfflineWorkspaceStarted){
                            <bizz-icon class="size-2.5 animate-spin text-blue-500 drop-shadow-sm" iconName="rotate"></bizz-icon>
                        }@else{
                            <bizz-icon class="ml-1 size-2.5 text-blue-500 drop-shadow-sm" (click)="startfetchingOfflineWorkspace()" iconName="play"></bizz-icon>
                        }
                    }
                    @case(SyncState.PAUSED){
                        <bizz-icon class="ml-1 size-2.5 text-blue-500 drop-shadow-sm" iconName="play"></bizz-icon>
                    }
                    @case(SyncState.SYNCING){
                        <bizz-icon class="size-2.5 animate-spin text-blue-500 drop-shadow-sm" iconName="rotate"></bizz-icon>
                    }
                    @case(SyncState.FAILED){
                        <bizz-icon class="size-2.5 text-orange-500 drop-shadow-sm" iconName="rotate-exclamation"></bizz-icon>
                    }
                }
            </div>
        </div>


        <!-- Optimized popup code -->
        <div #popup
             [ngClass]="{'invisible' : !showPopup, 'sm:overflow-y-clip' : !showPopup, 'sm:overflow-y-scroll' : showPopup}"
             class="no-scrollbar fixed right-0 top-0 z-[2000] flex h-svh w-svw flex-col items-end bg-transparent transition-all duration-300 ease-in-out sm:right-auto sm:top-auto sm:mt-[34px] sm:max-h-[90svh] sm:max-w-[27rem]">

            <div [ngClass]="{'translate-y-[0]' : showPopup, '!opacity-100' : showPopup, 'translate-y-[-110%]' : !showPopup, 'opacity-0' : !showPopup}"
                 class="shadow-black absolute flex h-full w-full flex-col bg-body-popup shadow-lg drop-shadow-xl transition-all duration-300 ease-in-out sm:h-auto sm:w-[27rem] sm:rounded">
                <!-- Optimized popup code end-->
                
                <div class="flex flex-col gap-3.5 p-4">
                    <div class="flex items-center font-bold">
                        <h1 class="flex flex-row items-center text-lg text-form-header">
                            <bizz-icon class="sm:h-size-5 mr-2.5 size-6 text-form-header"
                                       iconName="download"></bizz-icon>
                            {{ 'Syncing' | translate }}
                        </h1>
                        <button class="ml-auto w-fit !p-0" (click)="togglePopup()">
                            <bizz-icon class="sm:h-size-5 size-6 text-form-header"
                                       iconName="xmark"></bizz-icon>
                        </button>
                    </div>

                    <div class="flex items-center justify-between border-b-2 border-divider pb-2"></div>
                    @for (item of syncQueueService.queueItems; track $index) {
                        <div class="rounded-md bg-button-disabled/75 px-3 py-2">
                            <div class="flex justify-between">
                                <div class="flex flex-col">
                                    @if(item.type == SyncItemType.FOLDER){
                                        <div class="flex items-center gap-1.5">
                                            @if(item.failedObservables?.length){
                                                <bizz-icon class="size-3 text-orange-500" iconName="rotate-exclamation"></bizz-icon>
                                            }@else{
                                                <bizz-icon class="size-3 text-blue-500" iconName="rotate"></bizz-icon>
                                            }
                                            <span class="text-sm text-blue-500">{{ 'Syncing' | translate }} "{{ item.name }}"</span>
                                        </div>
                                        <span class="text-[10px] text-light"> {{ 'Downloading' | translate }} @if(item.subfolders){{{item.subfolders}} {{'subfolders' | translate}}, } {{item.totalProgress}} {{'records' | translate}}...
                                            @if(item.failedObservables?.length){({{item.failedObservables?.length}} {{'failed' | translate}})} </span>
                                    }@else if(item.type == SyncItemType.SINGLE){
                                        <div class="flex items-center gap-1.5">
                                            @if(item.failedObservables?.length){
                                                <bizz-icon class="size-3 text-orange-500" iconName="rotate-exclamation"></bizz-icon>
                                            }@else{
                                                <bizz-icon class="size-3 text-blue-500" iconName="rotate"></bizz-icon>
                                            }
                                            <span class="text-sm text-blue-500">{{ 'Syncing' | translate }} {{item.totalProgress}} {{'records from' | translate}} @if(item.name){"{{ item.name }}"}</span>
                                        </div>
                                        <span class="text-[10px] text-light">@if(item.failedObservables?.length){({{item.failedObservables?.length}} {{'failed' | translate}})}</span>
                                    }@else if(item.type == SyncItemType.METADATA){
                                        <div class="flex items-center gap-1.5">
                                            @if(item.failedObservables?.length){
                                                <bizz-icon class="size-3 text-orange-500" iconName="rotate-exclamation"></bizz-icon>
                                            }@else{
                                                <bizz-icon class="size-3 text-blue-500" iconName="rotate"></bizz-icon>
                                            }
                                        <span class="text-sm text-blue-500">{{ 'Syncing general info and tree structure' | translate }}</span>
                                        </div>
                                    }
                                    <div class="w-[270px]">
                                        <kendo-progressbar
                                                [value]="math.min(((item.currentProgress/item.totalProgress)*100), 100)"
                                                [label]="{visible: false}" [progressCssStyle]="progressStyles"
                                                [animation]="true"></kendo-progressbar>
                                    </div>
                                </div>
                                <div class="flex flex-col items-center justify-between">
                                @switch(syncQueueService.syncState$ | async) {
                                    @case(SyncState.PAUSED){
                                    <bizz-icon class="ml-1 size-6 cursor-pointer text-default" iconName="circle-play"
                                        (click)="syncQueueService.play()"></bizz-icon>
                                    }
                                    @case(SyncState.SYNCING){
                                    <bizz-icon class="ml-1 size-6 cursor-pointer text-default" iconName="circle-pause"
                                        (click)="syncQueueService.pause()"></bizz-icon>
                                    }
                                    @case(SyncState.FAILED){
                                    <bizz-icon class="ml-1 size-6 cursor-pointer text-default" iconName="circle-play"
                                        (click)="syncQueueService.retry(item)"></bizz-icon>
                                    }
                                }
                                <span class="text-[10px] text-light">
                                    {{ item.currentProgress }} of {{ item.totalProgress }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    }
                    <div>
                    </div>

                </div>
            </div>
        </div>
    }
</section>